module.exports = __webpack_public_path__ + "static/media/ab_tr_isbirligi_logo.963fa1a8.png";